import React from 'react';
import { Flex, Box, Container } from 'components/Grid';
import H1 from 'components/H1';
import Paragraph from 'components/Paragraph';
import Image from 'components/Image';
import MultiMediaBlock from 'components/MultiMediaBlock';
import styled from 'styled-components';
import handIcon from '../images/hand-hello.svg';
import Text from 'components/Text';

const ContactHeroStyled = styled(Flex)`
	.hand-icon {
		transform: translateY(11px);
	}
`;

const createContactText = str => {
	const addBreak = str.replace(/[\n]/g, ' __break__ ');

	const words = addBreak.split(' ');

	return words.map((word, i) => {
		if (word === '__break__') {
			return <br key={i} />;
		}

		if (word === '__hej__') {
			return (
				<Text key={i} large mb={[4, 0]} display="inline-flex" alignItems="center">
					<Image
						className="hand-icon"
						marginTop={'-20px'}
						mx={[2]}
						width="38px"
						src={handIcon}
						staticImg
					/>
				</Text>
			);
		}

		return ` ${word} `;
	});
};

const ContactHero = props => (
	<ContactHeroStyled bg="client.accent" mb={[2, 6]} px={[1, 4, 3]}>
		<Container size={'large'} pb={[0, 0, 0]}>
			<Flex>
				<Box>
					<H1 mb={2} color="client.primary">
						{props.page.headline}
					</H1>
				</Box>
			</Flex>
			<Flex top={[40, 70]} flexWrap="wrap">
				<Box width={[1, 1, 2 / 5]} pr={[0, 5]} className="ContactHero-Text">
					<Paragraph large>
						{createContactText(props.page.text.childMarkdownRemark.rawMarkdownBody)}
					</Paragraph>
				</Box>
				<Box className="ContactHero-Media" position="relative" width={[1, 1, 3 / 5]} height="400px">
					<MultiMediaBlock mediaEl={props.page.image} />
				</Box>
			</Flex>
		</Container>
	</ContactHeroStyled>
);

export default ContactHero;
